import { render, staticRenderFns } from "./error-reporting.vue?vue&type=template&id=0aff2c7d&lang=html"
import script from "./error-reporting.vue?vue&type=script&lang=js"
export * from "./error-reporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports